import React from 'react';
import { Cell, PieChart, Pie } from 'recharts';

const GaugeDraw = ({ data, angleValue, onClickGraphic, name, dataDev, colorGauge }) => {
  const chartValue = angleValue;
  const colorData = data;
  const color = colorGauge;
  
  const activeSectorIndex = colorData.map((cur, index, arr) => {
    const curMax = [...arr]
    .splice(0, index + 1)
    .reduce((a, b) => ({ value: a.value + b.value }))
    .value;
    return (chartValue > (curMax - cur.value)) && (chartValue <= curMax);
  }).findIndex(cur => cur);

  const sumValues = colorData
    .map(cur => cur.value)
    .reduce((a, b) => a + b);

  const arrowData = [
    { value: chartValue },
    { value: 0 },
    { value: sumValues - chartValue }
  ];

  const pieProps = {
    startAngle: 180,
    endAngle: 0,
    cx: 85,
    cy: 85
  };

  const pieRadius = {
    innerRadius: 60,
    outerRadius: 80
  };

  const Arrow = ({ cx, cy, midAngle, outerRadius }) => { //eslint-disable-line react/no-multi-comp
    const RADIAN = Math.PI / 180;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const mx = cx + (outerRadius + 12) * cos;
    const my = cy + (outerRadius + 12) * sin;
    return (
      <g>
        <circle cx={cx} cy={cy} r={20} fill={color} stroke="none" />
        <path d={`M${cx},${cy}L${mx},${my}`} strokeWidth="6" stroke={color} fill="none" strokeLinecap="round" />
      </g>
    );
  };

  const onClick = (tal, dos) => {
    try {
      onClickGraphic(name, dataDev[dos])
    } catch (e) { }
  }
  return (
    <PieChart width={180} height={130} className='centrar on-mouse-hover'
      onClick={onClick}>
      <Pie
        activeIndex={activeSectorIndex}
        dataKey={'value'}
        data={colorData}
        fill="#8884d8"
        {...pieRadius}
        {...pieProps}
        onClick={onClick}
        className='on-mouse-hover'
      >
        {
          colorData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colorData[index].color} />
          ))
        }
      </Pie>
      <Pie
        stroke="none"
        className='on-mouse-hover'
        activeIndex={1}
        dataKey={'value'}
        activeShape={Arrow}
        data={arrowData}
        outerRadius={pieRadius.innerRadius}
        fill="none"
        {...pieProps}
        onClick={onClick}
      />
    </PieChart>
  );
};

export default GaugeDraw;